import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

/**
 * Tournament standings styles (specs/champions-league, Story 5).
 * State treatments (empty / error / skeleton) deliberately mirror SeasonPicks so the two
 * screens in the same shell do not read as different products.
 */
export const getTournamentStandingsStyles = (theme: Theme) =>
  StyleSheet.create({
    screen: {
      flex: 1,
      backgroundColor: theme.background.primary,
    },
    listContent: {
      paddingHorizontal: 12,
      paddingTop: 12,
      paddingBottom: 32,
    },
    tableBlock: {
      marginBottom: 20,
    },
    heading: {
      fontSize: theme.typography.h3.fontSize,
      fontWeight: theme.typography.h3.fontWeight,
      color: theme.black,
      marginBottom: 8,
      marginLeft: 4,
    },
    centerWrap: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: 32,
      paddingBottom: 48,
    },
    emptyMonkey: { width: 100, height: 100, marginBottom: 16 },
    stateTitle: {
      fontSize: theme.typography.h3.fontSize,
      fontWeight: theme.typography.h3.fontWeight,
      color: theme.black,
      marginBottom: 8,
      textAlign: 'center',
    },
    stateSubtitle: {
      fontSize: theme.typography.bodySmall.fontSize,
      color: theme.gray[500],
      textAlign: 'center',
      lineHeight: 20,
      marginBottom: 24,
    },
    retryButton: {
      paddingHorizontal: 24,
      paddingVertical: 10,
      borderRadius: 20,
      backgroundColor: theme.primary,
    },
    retryLabel: { fontSize: 14, fontWeight: '700', color: theme.onPrimary },
    skeletonRow: {
      height: 44,
      borderRadius: 10,
      backgroundColor: theme.background.cardElevated,
      marginHorizontal: 12,
      marginTop: 12,
      opacity: 0.5,
    },
  });
